<template>
<section>
    <fixed-header title="BOM" :records="bomPageInfo.totalItems" hideBackBtn>
        <div class="buttons-panel m-0">
            <bom-import @refreshGrid="getAll({})" />
            <b-button size="sm" variant="primary" @click="$bvModal.show('import-bom-modal')" class="mr-2">
                <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import BOM
            </b-button>
        </div>
    </fixed-header>
    <div class="card">
        <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-start align-items-end mb-2">
                <b-form-group label="Customer" class="mr-2">
                    <b-form-input v-model="filterObj.customer" size="sm" type="text" id="customer-filter" @input="onSearch">
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Sales Rep" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_REQUIREMENTS)">
                    <!-- <b-form-input v-model="filterObj.salesRep" @input="onSearch" size="sm" /> -->
                    <b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
                    <option :value="null">All</option>
                    <option
                        v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                        :key="indexRep"
                        :value="selectRep.id"
                    >{{ selectRep.name }}</option>
                    </b-form-select>
                </b-form-group>
                <date-range-picker :dateFrom="filterObj.dateFrom" :dateTo="filterObj.dateTo" @handleSearch="onSearch"></date-range-picker>
                <!--<date-range-picker ref="dateRangePicker" :handleSearch="search"></date-range-picker>-->
                <div class="clear-filter-button-container">
                    <b-button size="sm" @click="clearFilter">Clear filters</b-button>
                </div>
            </div>
            <grid-component
                isResizable
                isReorderable
                isSortable
                :canEdit="checkClaim(CAN_EDIT_REQUIREMENTS)"
                :canDelete="checkClaim(CAN_DELETE_REQUIREMENTS)"
                :gridId="gridId"
                :pageable="pageable"
                :skip="bomPageInfo.pageSize * (bomPageInfo.pageNumber - 1)"
                :take="bomPageInfo.pageSize"
                :itemData="itemData"
                :pageSizes="bomPageInfo.pageSize"
                :totalItems="bomPageInfo.totalItems"
                :fields="fields"
                :sortBy="bomPageInfo.sortBy"
                :sortOrder="bomPageInfo.sortOrder"
                
                :onEdit="openEdit"
                :onDelete="onDelete"
                :handleRowClick="handleRowClick"
                :styleCustom="'height: 610px'"
                @getData="onGetData"
                :isTblLoader="tblLoader"
            />
        </div>        
    </div>
</section>
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex';
import debounce from 'lodash/debounce';
import { date } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_ID, GRID_PAGE_SIZES, SAVE_SETTINGS_DELAY, DATE_FORMAT } from '@/shared/constants';
import fields from './fields';
import BomImport from '../AddRequirement/components/BOM';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import GridComponent from '@/shared/components/GridComponent';
import GridSettings from '@/shared/components/GridSettings';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

export default {
    components: {
        BomImport,
        FixedHeader,
        GridComponent,
        GridSettings,
        DateRangePicker
    },  
    data() {
        return {
            fields,
            gridId: GRID_ID.REQUIREMENT_HEADER_GRID,
            pageable: {
                pageSizes: GRID_PAGE_SIZES,
            },
            filterPageName: 'bomRequirements',
            selectedRowItemId: 0,
            tblLoader: false
        }
    },
    computed: {
        ...mapState('salesReps', ['salesReps']),
        ...mapGetters('requirements', ['bomPageInfo', 'bomList', 'filters']),
        filterObj() {
            return this.filters[this.filterPageName] || {}
        },
        itemData() {
            return this.bomList.map((requirement) => ({ ...requirement, selected: requirement.id === this.selectedRowItemId }));
        }
    },
    methods: {
        ...mapMutations('requirements', ['setItem']),
        ...mapActions('requirements', [
            'getBOMs',
            'sortGrid',
            'search',
            'deleteRequirement',
        ]),
        openEdit(row) {
            this.$emit('onClickBOM', { id: row.id, rfqNum: row.requirementNumber});
        },
        handleRowClick({dataItem}) {
            this.selectedRowItemId = dataItem.id;
        },
        async onGetData(params) {
            await this.getBOMs(params);
        },
        onSearch: debounce(function(data = false) {
            if(typeof data === 'object') { Object.assign(this.filterObj,data) }
            this.getBOMs({ ...this.bomPageInfo, filters: this.filterObj });
        }, SEARCH_DEBOUNCE_TIME),
        clearFilter(callSearch = true) {
            this.clearObject(this.filterObj);
            if (callSearch) {
                this.search({'filters':this.filterObj,page:this.filterPageName});
            }
        },
        async onDelete({ id }) {
            const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete requirement?  This action cannot be undone.`});
            if (deleteConfirmed) {
                //await this.deleteCrfqPart(part.id);
                await this.deleteRequirement(id);
                //Get the data
                this.getBOMs({});
            }
        }
    },
    mounted() {
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
    //   this.setItem({ resource: 'bomPageInfo', payload: {...this.bomPageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      this.getBOMs({});
    },
    beforeDestroy() {},
}

</script>